import locale from "../../lib/locales/pt.json";

window.I18nlocales = window.I18nlocales || [];
window.I18nlocales.push(locale);
